// extracted by mini-css-extract-plugin
export default {"cls1":"R_wahi798D3tRXj0hIzQ","cls2":"jOPr67hKsluYoss3kMY3 R_wahi798D3tRXj0hIzQ","isPhone":"YxpgnAegpl2eu6rECoZ7"};